import { actionHistoryApiService } from '../../../../shared/service/api/actionHistoryApiService';
import { ActionHistoryType } from '../types/actionHistoryType';

class ActionHistoryService {
  async fetchUserActionHistory(
    params: URLSearchParams
  ): Promise<{ data: ActionHistoryType[]; count: number }> {
    const { results, count } = await actionHistoryApiService.fetchBySubPath<ActionHistoryType>(
      'user_action_history/',
      params
    );
    return { data: results, count };
  }

  async fetchObjectActionHistory(
    params: URLSearchParams
  ): Promise<{ data: ActionHistoryType[]; count: number }> {
    const { results, count } = await actionHistoryApiService.fetchBySubPath<ActionHistoryType>(
      'object_action_history/',
      params
    );
    return { data: results, count };
  }

  async fetchActionHistoryList(
    params: URLSearchParams
  ): Promise<{ data: ActionHistoryType[]; count: number }> {
    const { results, count } = await actionHistoryApiService.fetch(params);
    return { data: results, count };
  }

  async fetchByParent(
    parentType: string,
    parentId: number,
    additionalParams?: URLSearchParams
  ): Promise<{ data: ActionHistoryType[]; count: number }> {
    const params = new URLSearchParams({
      parent_type: parentType,
      parent_id: parentId.toString(),
    });
    // 추가 파라미터가 있으면 병합
    if (additionalParams) {
      additionalParams.forEach((value, key) => {
        params.append(key, value);
      });
    }
    const { results, count } = await actionHistoryApiService.fetch(params);
    return { data: results, count };
  }
}

export const actionHistoryService = new ActionHistoryService();
